var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-6 pl-lg-5"},[_c('header',{staticClass:"row"},[_c('div',{staticClass:"fl-y fl-a-s mb-2"},[_vm._t("header")],2)]),_c('section',{staticClass:"row"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }